export const InteractionPageEnum = {
  CREATE_TICKET: "CREATE_TICKET",
  ALL_TICKETS: "ALL_TICKETS",
  MY_TICKETS: "MY_TICKETS",
  MY_TEAMS: "MY_TEAMS",
  MY_DEPARTMENTS: "MY_DEPARTMENTS",
  MY_DRAFTS: "MY_DRAFTS",
  ALL_SOFT_ALERTS: "ALL_SOFT_ALERTS",
  MY_SOFT_ALERTS: "MY_SOFT_ALERTS",
  ALL_INTERACTIONS: "ALL_INTERACTIONS",
  VA_INTERACTIONS: "VA_INTERACTIONS",
  UNKNOWN_USER_TICKETS: "UNKNOWN_USER_TICKETS",
};

export const ticketCategories = {
  [InteractionPageEnum.ALL_TICKETS]: {
    text: "All Tickets",
    value: InteractionPageEnum.ALL_TICKETS,
    count: true,
    displayCircle: false,
    route: "/inbox/tickets/all",
    countKey: "all_tickets",
  },
  [InteractionPageEnum.MY_TICKETS]: {
    text: "My Tickets",
    value: InteractionPageEnum.MY_TICKETS,
    count: true,
    displayCircle: false,
    route: "/inbox/tickets/mine",
    countKey: "my_tickets",
  },
  [InteractionPageEnum.MY_TEAMS]: {
    text: "My Teams",
    value: InteractionPageEnum.MY_TEAMS,
    count: false,
    displayCircle: false,
    route: "/inbox/tickets/teams",
    countKey: "my_teams",
  },
  [InteractionPageEnum.MY_DEPARTMENTS]: {
    text: "My Departments",
    value: InteractionPageEnum.MY_DEPARTMENTS,
    count: false,
    displayCircle: false,
    route: "/inbox/tickets/departments",
    countKey: "my_departments",
  },
  [InteractionPageEnum.UNKNOWN_USER_TICKETS]: {
    text: "Unknown User Tickets",
    value: InteractionPageEnum.UNKNOWN_USER_TICKETS,
    count: true,
    displayCircle: false,
    route: "/inbox/tickets/unknown",
    countKey: "unknown_user_tickets",
  },
  [InteractionPageEnum.MY_DRAFTS]: {
    text: "My Drafts",
    value: InteractionPageEnum.MY_DRAFTS,
    count: false,
    displayCircle: false,
    route: "/inbox/tickets/drafts",
  },
};

export const softAlertsCategories = {
  ALL_SOFT_ALERTS: {
    text: "All Soft Alerts",
    value: InteractionPageEnum.ALL_SOFT_ALERTS,
    count: true,
    displayCircle: false,
    route: "/inbox/soft-alerts/all",
    countKey: "all_soft_alerts",
  },
  MY_SOFT_ALERTS: {
    text: "My Soft Alerts",
    value: InteractionPageEnum.MY_SOFT_ALERTS,
    count: true,
    displayCircle: false,
    route: "/inbox/soft-alerts/mine",
    countKey: "my_soft_alerts",
  },
};

export const interactionsCategories = {
  VA_INTERACTIONS: {
    text: "AI Agent",
    count: true,
    value: InteractionPageEnum.VA_INTERACTIONS,
    route: "/inbox/interactions/va",
    countKey: "va_interactions",
  },
  ALL_INTERACTIONS: {
    text: "All Engagement",
    count: true,
    value: InteractionPageEnum.ALL_INTERACTIONS,
    route: "/inbox/interactions/all",
    countKey: "all_interactions",
  },
};

export const allCategories = {
  ...ticketCategories,
  ...softAlertsCategories,
  ...interactionsCategories,
};
export const allSubMenus = [
  { title: "Tickets", children: Object.values(ticketCategories) },
  { title: "Soft Alerts", children: Object.values(softAlertsCategories) },
  { children: Object.values(interactionsCategories) },
];
